/**
 * Base URL del backend `liquitech-integration-service`. Único lugar donde vive este valor
 * (ver CLAUDE.md §servicios): todos los servicios HTTP lo importan de aquí.
 */
//export const API_BASE_URL = 'http://localhost:3000/api';
export const API_BASE_URL = 'https://dev.gateway.gondola.tiendasisimo.com/factoring';
